import styled from "styled-components";

/**
 * Wrapper do componente FlightSegment
 * Organiza o layout principal para exibir os detalhes do voo.
 */
export const StyledFlightSegment = styled.div`
  padding: 0 ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
  align-items: center;
  display: flex;
  width: auto;
  img {
    width: 65px;
    height: auto;
  }

  @media (max-width: 475px) {
    img {
      width: 45px;
      height: auto;
    }
  }
`;

/**
 * Wrapper dos detalhes do segmento
 * Contém informações como data, horários e aeroportos.
 */
export const SegmentDetails = styled.div`
  /* margin-left: ${({ theme }) => theme.spacing(2)}; */
  gap: ${({ theme }) => theme.spacing(1)};
  position: relative;
  align-items: center;
  flex-direction: row;
  display: flex;
  width: 100%;
  justify-content: space-around;

  & > svg {
    color: ${({ theme }) => theme.colors.mediumBlue};
    stroke: ${({ theme }) => theme.colors.mediumBlue};
    stroke-width: 1;

    position: absolute;
    left: ${({ theme }) => theme.spacing(-3)};
    top: ${({ theme }) => theme.spacing(2.5)};
  }
`;

/**
 * Bloco de data do voo
 * Exibe a data e o dia da semana.
 */
export const FlightDateBlock = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;

  @media (max-width: 475px) {
    font-size: 0.6rem;

    & > span {
      font-size: 0.7rem;
    }
  }
`;

/**
 * Bloco de informações do voo
 * Contém horários e códigos de aeroportos.
 */
export const FlightInfoBlock = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;

  @media (max-width: 475px) {
    font-size: 0.6rem;

    & > span {
      font-size: 0.7rem;
    }
  }
`;

/**
 * Wrapper do trajeto do voo
 * Agrupa as informações de partida, chegada e status.
 */
export const FlightPath = styled.div`
  padding: ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(4)};
  align-items: center;
  flex-direction: row;
  display: flex;

  @media (max-width: 475px) {
    gap: ${({ theme }) => theme.spacing(1)};
  }
`;

/**
 * Bloco de status do voo
 * Exibe paradas, duração e outros detalhes.
 */
/**
 * Bloco de status do voo
 * Exibe paradas, duração e outros detalhes.
 */
export const FlightStatus = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spacing(0.5)};

  & > span {
    margin-bottom: ${({ theme }) => theme.spacing(-0.85)};
    margin-left: ${({ theme }) => theme.spacing(-1.25)};
    margin-top: ${({ theme }) => theme.spacing(-0.5)};
  }

  @media (max-width: 475px) {
    font-size: 0.6rem;
    gap: ${({ theme }) => theme.spacing(0.25)};

    & > span {
      font-size: 0.6rem;
      margin-bottom: ${({ theme }) => theme.spacing(-0.5)};
      margin-left: ${({ theme }) => theme.spacing(-0.75)};
      margin-top: ${({ theme }) => theme.spacing(-0.25)};
    }

    svg {
      width: 13px; /* Reduz o tamanho dos ícones */
      height: 13px;
    }
  }
`;
